import useChat from "hooks/useChat";
import useFarmChat from "hooks/useFarmChat";
import { MouseEvent } from "react";
import { useIntl } from "react-intl";
import { ChatIcon } from "Assets/icons";
import { useHistory, useLocation } from "react-router-dom";
import { PATHS } from "constants/routes";
import TextButton from "./TextButton";
// import Tooltip from "components/tooltip/Tooltip";

const ChatNowButton = ({
  identity,
  isFarmChat = false,
}: {
  identity?: string;
  isFarmChat?: boolean;
}) => {
  const { onOpenConversationWithIdentity } = useChat();
  const { onOpenConversationWithIdentity: onOpenFarmConversationWithIdentity } = useFarmChat();
  const t = useIntl();
  const history = useHistory();
  const location = useLocation();

  console.log('isFarmChat', isFarmChat);
  const onClickButton = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (identity) {
      if (isFarmChat) {
        // Use farm chat functionality
        onOpenFarmConversationWithIdentity(identity);
        // Farm chat always goes to business messages
        history.push(PATHS.bizMessages);
      } else {
        // Use regular chat functionality
        onOpenConversationWithIdentity(identity);
        // Regular chat follows current path logic
        const isBusinessPath = location.pathname.includes('/business');
        history.push(isBusinessPath ? PATHS.bizMessages : PATHS.messages);
      }
    }
  };

  return (
    // <Tooltip title={t.formatMessage({ id: "send_quotation_to_start_chat" })}>
    <>
      <TextButton
        onClick={onClickButton}
        className="send-msg-btn"
        sx={{
          flexDirection: "row",
          textTransform: "none",
          gap: '8px',
          border: '1px solid #008934',
          borderRadius: "8px",
          color: '#008934',
          padding: '8px 12px',
          fontSize: '14px',
        }}
      >
        {t.formatMessage({ id: "chat_now" })}
        <ChatIcon color="#008934" stroke="#008934" width={20} height={20} />
      </TextButton>
    </>
    // </Tooltip>
  );
};

export default ChatNowButton;
